var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80394 5.10718C7.86212 5.49953 7.79511 5.90024 7.61245 6.2523C7.42978 6.60437 7.14077 6.88987 6.78651 7.0682C6.43225 7.24652 6.03079 7.30859 5.63922 7.24558C5.24766 7.18257 4.88593 6.99768 4.60549 6.71721C4.32505 6.43674 4.14018 6.07498 4.07717 5.68338C4.01416 5.29177 4.07623 4.89027 4.25454 4.53598C4.43284 4.18169 4.71832 3.89264 5.07035 3.70996C5.42238 3.52728 5.82305 3.46027 6.21536 3.51845C6.61554 3.57779 6.98601 3.76428 7.27207 4.05037C7.55813 4.33646 7.7446 4.70697 7.80394 5.10718Z",
    stroke: "white",
    strokeWidth: 0.942823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27567 0.689453H3.56161C2.25987 0.689453 1.20459 1.7448 1.20459 3.04663V7.76099C1.20459 9.06282 2.25987 10.1182 3.56161 10.1182H8.27567C9.57741 10.1182 10.6327 9.06282 10.6327 7.76099V3.04663C10.6327 1.7448 9.57741 0.689453 8.27567 0.689453Z",
    stroke: "white",
    strokeWidth: 0.942823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51172 2.81152H8.51733",
    stroke: "white",
    strokeWidth: 0.942823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.68fb6482e754b099d28d6e5abf04ba7d.svg";
export { ForwardRef as ReactComponent };